const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

// Cardi: reset cart on every new visit (added by Claude)
(function () {
  try {
    if (window.Shopify && Shopify.designMode) return;
    var now = Date.now();
    var sameTab = sessionStorage.getItem('cardi-visit');
    var lastSeen = parseInt(localStorage.getItem('cardi-hb') || '0', 10);
    sessionStorage.setItem('cardi-visit', '1');
    var tick = function () { localStorage.setItem('cardi-hb', String(Date.now())); };
    tick();
    setInterval(tick, 5000);
    if (!sameTab && (!lastSeen || now - lastSeen > 20000)) {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        if (c && c.item_count > 0) {
          return fetch('/cart/clear.js', { method: 'POST' }).then(function () { location.reload(); });
        }
      }).catch(function () {});
    }
  } catch (e) {}
})();
